import css from "./Card.module.css";

export interface CardProps {
  className?: string;
  content: JSX.Element | JSX.Element[];
  media?: JSX.Element | JSX.Element[];
}

const BASE_CLASS = "f-AtomCard";

export const Card = ({ className, media, content }: CardProps) => {
  return (
    <div className={`${css[BASE_CLASS]} ${className}`}>
      {media && <div className={css[`${BASE_CLASS}-media`]}>{media}</div>}
      {content && <div className={css[`${BASE_CLASS}-content`]}>{content}</div>}
    </div>
  );
};
